import React, { useEffect } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomVerticalTabs from "components/CustomVerticalTabs/CustomVerticalTabs";
import TabContent from "./TabContent";
import { action } from "variables/action";

export default function AboutTabs({
  general,
  details,
  impact,
  projections,
  progress,
  results,
  comments,
  planActionId,
  groupParent,
}) {

  let generalNoData = {},
    detailsNoData = {},
    impactNoData = {},
    projectionsNoData = {};

  function NoData(params, noDataObject) {
    for (const [key, value] of Object.entries(params)) {
      noDataObject[key] = "";
    }
  }

  NoData(action.general, generalNoData);
  NoData(action.details, detailsNoData);
  NoData(action.impact, impactNoData);
  NoData(action.projections, projectionsNoData);

  const dataWithoutProjections = [
    {
      value: 0,
      name: "Paramètres généraux",
      component: (
        <TabContent
          apiData={general || generalNoData}
          params="general"
          groupParent={groupParent}
        />
      ),
    },

    {
      value: 1,
      name: "Détails de l'action",
      component: (
        <TabContent apiData={details || detailsNoData} params="details" />
      ),
    },
    {
      value: 2,
      name: `Paramètres considérés & impacts`,
      component: (
        <TabContent
          apiData={impact || impactNoData}
          params="impact"
          category={general.category}
        />
      ),
    },
    {
      value: 3,
      name: `Etat d'avancement`,
      component: (
        <TabContent
          apiData={progress}
          params="progress"
          planActionId={planActionId}
        />
      ),
    },
    {
      value: 4,
      name: `Validation de l'action - Résultats`,
      component: (
        <TabContent
          apiData={results}
          params="results"
          planActionId={planActionId}
          category={general.category}
        />
      ),
    },
    {
      value: 5,
      name: `Commentaires`,
      component: (
        <TabContent
          apiData={comments}
          params="comments"
          planActionId={planActionId}
        />
      ),
    },
  ];
  const dataWithProjections = [
    {
      value: 0,
      name: "Paramètres généraux",
      component: (
        <TabContent
          apiData={general || generalNoData}
          params="general"
          groupParent={groupParent}
        />
      ),
    },

    {
      value: 1,
      name: "Détails de l'action",
      component: (
        <TabContent apiData={details || detailsNoData} params="details" />
      ),
    },
    {
      value: 2,
      name: `Paramètres considérés & impacts`,
      component: (
        <TabContent
          apiData={impact || impactNoData}
          params="impact"
          category={general.category}
        />
      ),
    },
    {
      value: 3,
      name: `Projections`,
      component: (
        <TabContent
          apiData={projections || projectionsNoData}
          params="projections"
          category={general.category}
        />
      ),
    },
    {
      value: 4,
      name: `Etat d'avancement`,
      component: (
        <TabContent
          apiData={progress}
          params="progress"
          planActionId={planActionId}
        />
      ),
    },
    {
      value: 5,
      name: `Validation de l'action - Résultats`,
      component: (
        <TabContent
          apiData={results}
          params="results"
          planActionId={planActionId}
          category={general.category}
        />
      ),
    },
    {
      value: 6,
      name: `Commentaires`,
      component: (
        <TabContent
          apiData={comments}
          params="comments"
          planActionId={planActionId}
        />
      ),
    },
  ];

  return (
    <CustomVerticalTabs
      data={
        general.category !== "engineeringstudy"
          ? dataWithProjections
          : dataWithoutProjections
      }
    />
  );
}
